import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAlphaNumOnly]'
})
export class AlphaNumOnlyDirective {

  constructor(private el: ElementRef, renderer: Renderer2) {

    renderer.listen(el.nativeElement, 'keypress', event => {

      if (event.ctrlKey || event.metaKey || event.altKey) {
        return true;
      }
      const charCode = (event.which) ? event.which : event.keyCode;

      if((charCode >= 47 && charCode <=57) || (charCode >= 97 && charCode <=122) ||
      (charCode >= 65 && charCode <= 90)) {
        return true;
      }
      else {
        return false;
      }
    });
   }
   
}
